var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLandingCivil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_1152)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.27539,
    y: -0.046875,
    width: 31.6848,
    height: 13.2392,
    rx: 6.61959,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0194 16.3164L11.3784 11.7422L16.6603 11.7422L14.0194 16.3164Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1097 16.3164L24.4688 11.7422L29.7506 11.7422L27.1097 16.3164Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.241,
    cy: 20.4959,
    rx: 3.49592,
    ry: 3.49592,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9203 25.8548L13.9303 23.2911L10.8228 20.8828L10.0459 25.8548H12.9203Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0752 19.5625L17.4256 19.0963C16.8041 17.1542 14.2405 16.2996 12.2206 17.6203C10.6047 18.6768 10.6151 20.5465 10.8222 21.3493L13.0752 19.5625Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27501 26.7437C4.65689 25.4766 5.82397 24.6094 7.1474 24.6094H15.9522C17.9633 24.6094 19.4049 26.5494 18.8246 28.475L17.2145 33.8174C16.8327 35.0845 15.6656 35.9517 14.3422 35.9517H5.53738C3.52622 35.9517 2.08467 34.0117 2.66499 32.0861L4.27501 26.7437Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.999 28.6523C12.6566 28.6523 11.513 29.6979 11.109 30.2207L11.4819 31.6045H13.16C13.5329 31.6045 14.0922 31.42 14.4651 31.1432C14.7634 30.9218 15.0866 30.2514 15.2109 29.9439C16.5161 29.9439 17.6348 29.8516 17.6348 29.3904C17.6348 28.9291 15.677 28.6523 13.999 28.6523Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.49592,
    cy: 3.49592,
    rx: 3.49592,
    ry: 3.49592,
    transform: "matrix(-1 0 0 1 30.3643 17)",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.189 25.8548L27.1791 23.2911L30.2866 20.8828L31.0635 25.8548H28.189Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0337 19.5625L23.6832 19.0963C24.3047 17.1542 26.8684 16.2996 28.8883 17.6203C30.5042 18.6768 30.4938 20.5465 30.2867 21.3493L28.0337 19.5625Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8339 26.7437C36.452 25.4766 35.2849 24.6094 33.9615 24.6094H25.1567C23.1456 24.6094 21.704 26.5494 22.2843 28.475L23.8943 33.8174C24.2762 35.0845 25.4433 35.9517 26.7667 35.9517H35.5715C37.5827 35.9517 39.0242 34.0117 38.4439 32.0861L36.8339 26.7437Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3887 28.6523C28.7311 28.6523 29.8747 29.6979 30.2787 30.2207L29.9058 31.6045H28.2277C27.8548 31.6045 27.2955 31.42 26.9226 31.1432C26.6242 30.9218 26.3011 30.2514 26.1768 29.9439C24.8716 29.9439 23.7529 29.8516 23.7529 29.3904C23.7529 28.9291 25.7106 28.6523 27.3887 28.6523Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8474 3.15828L17.7274 8.11828H16.4674L16.3474 3.15828H17.8474ZM16.2874 9.49828C16.2674 9.05828 16.6474 8.68828 17.1074 8.69828C17.5374 8.68828 17.9174 9.05828 17.9274 9.49828C17.9174 9.95828 17.5374 10.3283 17.1074 10.3183C16.6474 10.3283 16.2674 9.95828 16.2874 9.49828ZM20.904 3.15828L20.784 8.11828H19.524L19.404 3.15828H20.904ZM19.344 9.49828C19.324 9.05828 19.704 8.68828 20.164 8.69828C20.594 8.68828 20.974 9.05828 20.984 9.49828C20.974 9.95828 20.594 10.3283 20.164 10.3183C19.704 10.3283 19.324 9.95828 19.344 9.49828ZM23.9607 3.15828L23.8407 8.11828H22.5807L22.4607 3.15828H23.9607ZM22.4007 9.49828C22.3807 9.05828 22.7607 8.68828 23.2207 8.69828C23.6507 8.68828 24.0307 9.05828 24.0407 9.49828C24.0307 9.95828 23.6507 10.3283 23.2207 10.3183C22.7607 10.3283 22.3807 9.95828 22.4007 9.49828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_1152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLandingCivil);
export default __webpack_public_path__ + "static/media/IcLandingCivil.c98cdb151050ab25ddb03f6d45ae70d5.svg";
export { ForwardRef as ReactComponent };